
import {
  validatenull,
} from './validate';
import Vue from 'vue';
import CryptoJS from 'crypto-js';
import {base64Encode} from "@/util/endecode";
let Base64 = require('js-base64').Base64

export const initMenu = (router, menu) => {
  if (menu.length === 0) {
    return;
  }
  router.addRoutes(formatRoutes(menu));
};

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy (obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
 * 获取有权限的菜单
 */
export const getAuthorizedMenu = (menu, pmsSet, type = 'menu') => {
  if (!menu) return;
  const authorizedMenu = [];
  for (let i = 0; i < menu.length; i++) {
    const subMenus = menu[i].children;
    if(!menu[i].type) {
      menu[i].type = 'menu'
    }
    if (menu[i].type === type) {
      if(menu[i].permission=='home_page_menu'){
        authorizedMenu.push(menu[i]);
      }
      // 菜单无法点击并且存在子节点
      if (subMenus && subMenus.length > 0) {
        // 将子节点替换为有权限的子节点
        menu[i].children = getAuthorizedMenu(subMenus, pmsSet);
        if (menu[i].children.length > 0) {
          authorizedMenu.push(menu[i]);
        }
        // 菜单可以点击，有权限访问，并且不存在子节点
      } else if (pmsSet.indexOf(menu[i].permission)!=-1 && !subMenus) {
        authorizedMenu.push(menu[i]);
      }
    }
  }
  // 返回有权限的子节点，这里根据 实际后端权限判断
  return authorizedMenu;
  //return menu;
};

export const downloadFile = (resp) => {
  const data = resp.data;
  if (resp.headers && resp.headers['content-disposition']) {
    let filename = resp.headers['content-disposition'].substring(resp.headers['content-disposition'].indexOf('fileName=') + 'fileName='.length);
    filename = decodeURIComponent(filename);
    const blob = new Blob([data], {
      type: 'application/octet-stream',
    });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(blob, filename);
    } else {
      const blobURL = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }
  }
};

// 根据线上地址下载pdf文件
export const downloadFileByUrl = (filePath, fileName) => {
  const parts = filePath.split('/');
  const fid = Base64.encode(encrypt(parts[parts.length - 1],'payrollEncry24pt'));
  filePath = filePath.substring(0, filePath.lastIndexOf('/')+1);
  filePath = filePath+fid;
  const xhr = new XMLHttpRequest();
  xhr.open('GET', filePath, true);
  xhr.responseType = 'blob';
  xhr.onload = () => {
    if (xhr.status === 200) {
      const blob = new Blob([xhr.response], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
    }
  };
  xhr.send();
}
/**
 * 获取树指定节点的父id
 * @param pId
 * @param treeData
 * @returns {*}
 */
export const getTreePid = (pId, treeData) => {
  let temp = null;
  getPid(null, treeData);
  return temp;
  function getPid(pNode, cNode) {
    if (cNode.id === pId) {
      return temp = pNode;
    }
    if (cNode.children) {
      for (let i = 0; i < cNode.children.length; i++) {
        getPid(cNode, cNode.children[i]);
      }
    }
  }
};

/**
 * 获取当前节点所有子节点id
 * @param treeData
 * @returns {Array}
 */
export const getTreeChildrenId = (treeData) => {
  const temp = [];
  temp.push(treeData.id);
  getPid(treeData);
  return temp;
  function getPid(node) {
    if (node.children.length == 0) {
      return;
    }
    for (let i = 0; i < node.children.length; i++) {
      temp.push(node.children[i].id);
      getPid(node.children[i]);
    }
  }
};

/**
 * 从根节点开始获取当前节点所有父节点id
 * @param treeData
 * @returns {Array}
 */
export const getTreeAllPid = (treeData, nodeId) => {
  let temp = [];
  let isEnd = false;
  const id = `${nodeId}`;
  for (let i = 0; i < treeData.length; i++) {
    if (isEnd) break;
    temp = [];
    getPid(treeData[i]);
  }
  return isEnd ? temp : [];
  function getPid(node) {
    temp.push(node.id);
    if (node.id === id) {
      isEnd = true;

      // temp.push(node.id)
    } else if (!isEnd) {

      if (!node.children || node.children.length === 0) {
        // 叶子节点删除数据
        temp.pop();
      } else {
        for (let i = 0; i < node.children.length; i++) {
          if (isEnd) break;
          // temp.push(node.id)
          getPid(node.children[i]);
          if (!isEnd && i !== 0 && i === node.children.length - 1) {
            // 当前所有子节点没有找到匹配数据，返回上一层级
            temp.pop();
          }
        }
      }
    }
  }
};

/**
 * 清除叶子节点所有空Children属性
 * @param treeData
 * @returns {Array}
 */
export const clearEmptyTreeChildren = (treeData) => {
  // const temp = []
  // temp.push(treeData.id)
  treeData.forEach((data) => {
    getPid(data);
  });
  // getPid(treeData)
  // return temp
  function getPid(node) {
    if (node.children.length === 0) {
      Vue.delete(node, 'children');
      return;
    }
    for (let i = 0; i < node.children.length; i++) {
      // temp.push(node.children[i].id)
      getPid(node.children[i]);
    }
  }
};
export const formatRoutes = (aMenu) => {

  const aRouter = [];
  aMenu.forEach((oMenu) => {
    const {
      path,
      component,
      name,
      icon,
      children,
    } = oMenu;
    if (!validatenull(component)) {
      let filePath;
      const oRouter = {
        path,
        component(resolve) {
          let componentPath = '';
          if (component === 'Layout') {
            require(['../page/index'], resolve);
            // () => import('../page/index')
            return;
          }
          componentPath = component;

          // () => import(`../${componentPath}.vue`)
          require([`../${componentPath}.vue`], resolve);
        },
        name,
        icon,
        children: validatenull(children) ? [] : formatRoutes(children),
      };
      aRouter.push(oRouter);
    }
  });
  return aRouter;
};

/**
 * 加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key,
  } = params;
  const result = JSON.parse(JSON.stringify(data));
  console.log(params, 'params')
  if (type === 'Base64') {
    param.forEach((ele) => {
      result[ele] = btoa(result[ele]);
    });
  } else {
    param.forEach((ele) => {
      const data = result[ele];
      key = CryptoJS.enc.Latin1.parse(key);
      const iv = key;
      // 加密
      const encrypted = CryptoJS.AES.encrypt(
        data,
        key,
        { iv,
          momoblede: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding,
        });
      result[ele] = encrypted.toString();
    });
  }
  return result;
};

/**
 * 设置浏览器头部标题
 */
export const setTitle = function (title) {
  title = title ? `${title}` : '主薪谷';
  window.document.title = title;
};
/**
 * 浏览器判断是否全屏
 */
export const fullscreenToggel = () => {
  if (fullscreenEnable()) {
    exitFullScreen();
  } else {
    reqFullScreen();
  }
};
/**
 * esc监听全屏
 */
export const listenfullscreen = (callback) => {
  function listen() {
    callback();
  }
  document.addEventListener('fullscreenchange', (e) => {
    listen();
  });
  document.addEventListener('mozfullscreenchange', (e) => {
    listen();
  });
  document.addEventListener('webkitfullscreenchange', (e) => {
    listen();
  });
  document.addEventListener('msfullscreenchange', (e) => {
    listen();
  });
};


/**
 * 浏览器判断是否全屏
 */
export const fullscreenEnable = () => {
  return document.fullscreenElement    ||
    document.msFullscreenElement  ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement || false;
};

/**
 * 浏览器全屏
 */
export const reqFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen();
  }
};

/**
 * 浏览器退出全屏
 */
export const exitFullScreen = () => {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen();
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen();
  }
};

/**
 * 递归寻找子类的父类
 */
export const findParent = (menu, id) => {
  for (let i = 0; i < menu.length; i++) {
    if (menu[i].children.length !== 0) {
      for (let j = 0; j < menu[i].children.length; j++) {
        if (menu[i].children[j].id === id) {
          return menu[i];
        }
        if (menu[i].children[j].children.length !== 0) {
          return findParent(menu[i].children[j].children, id);
        }
      }
    }
  }
};

/**
 * 总体路由处理器
 */
export const resolveUrlPath = (url, name) => {
  let reqUrl = url;
  // if (url.indexOf('#') !== -1 && url.indexOf('http') === -1) {
  //   const port = reqUrl.substr(reqUrl.indexOf(':'));
  //   reqUrl = `/myiframe/urlPath?src=${baseUrl}${port}${reqUrl.replace('#', '').replace(port, '')}}&name=${name}`;
  // } else if (url.indexOf('http') !== -1) {
  //   reqUrl = `/myiframe/urlPath?src=${reqUrl}&name=${name}`;
  // } else {
  //   reqUrl = `${reqUrl}`;
  // }
  return reqUrl;
};

/**
 * 总体路由设置器
 */
export const setUrlPath = ($route) => {
  let value = '';
  if ($route.query.src) {
    value = $route.query.src;
  } else {
    value = $route.path;
  }
  return value;
};

/**
 * 动态插入css
 */
export const loadStyle = (url) => {
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  const head = document.getElementsByTagName('head')[0];
  head.appendChild(link);
};

/**
 * 根据字典的value显示label
 */
export const findByvalue = (dic, value) => {
  let result = '';
  if (validatenull(dic)) return value;
  if (typeof (value) === 'string' || typeof (value) === 'number') {
    let index = 0;
    index = findArray(dic, value);
    if (index !== -1) {
      result = dic[index].label;
    } else {
      result = value;
    }
  } else if (value instanceof Array) {
    result = [];
    let index = 0;
    value.forEach((ele) => {
      index = findArray(dic, ele);
      if (index !== -1) {
        result.push(dic[index].label);
      } else {
        result.push(value);
      }
    });
    result = result.toString();
  }
  return result;
};

/**
 * 根据字典的value查找对应的index
 */
export const findArray = (dic, value) => {
  for (let i = 0; i < dic.length; i++) {
    if (dic[i].value === value) {
      return i;
    }
  }
  return -1;
};

/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = '';
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, typeof len === 'number' ? len : 4);
  if (date) random += Date.now();
  return random;
};
//aes 加密
export const encrypt = (word, keyStr) => {
  keyStr = keyStr ? keyStr : 'groupappEncrypk1';
  var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return encrypted.toString();
};
//aes 解密
export const decrypt = (word, keyStr) => {
  keyStr = keyStr ? keyStr : 'groupappEncrypk1';
  var key  = CryptoJS.enc.Utf8.parse(keyStr);//Latin1 w8m31+Yy/Nw6thPsMpO5fg==
  var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}
export const guid = () =>{
  function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  }
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
//判断元素是否有改class
export const hasClass = (element, className) =>{
  var reg = new RegExp('(\\s|^)'+className+'(\\s|$)');
  return element.className.match(reg);
  }

//给元素加class
export const addClass = (element, className) =>{
  if (!hasClass(element, className)){
  element.className = element.className+ " "+className;
  }
}
//给元素移除class
export const removeClass = (element, className) =>{
  if (hasClass(element, className)) {
    var reg = new RegExp('(\\s|^)'+className+'(\\s|$)');
    element.className = element.className.replace(reg,' ');
  }
}

// 云管家菜单
export const dataToTree = (data) => {
  let dataNew = data;
  let result = [];
  let map = {};
  const dataSystem = [
    { id: 'ac050c26053f46d1bb8a13299ab8631e', label: '社保公积金', pid: null, iconCls: "fa fa-info-circle", children: []},
    { id: 'ac050c26053f47d1bb8a13299ab8629e', label: '合同管理', pid: null, iconCls: "fa fa-user-plus", children: [] },
    { id: 'aa050c26053f47d1bb8a13299ab8629e', label: '智享签', pid: null, iconCls: "fa fa-file-pdf-o", children: [] },
  ];
  if(!Array.isArray(dataNew)) {
    return result;
  }
  // dataNew = dataNew.concat(dataSystem);
  dataNew.forEach(item => {
    if (!item.pid && item.appId) {
      item.pid = item.appId;
    }
    delete item.children;
    map[item.id] = item;
  });
  dataNew.forEach(item => {
    let parent = map[item.pid];
    if(parent) {
      (parent.children || (parent.children = [])).push(item);
    } else {
      result.push(item);
    }
  });
  dataSystem.forEach(item => {
    result.forEach(subItem => {
      if (item.id == subItem.appId) {
        item.children.push(subItem);
      }
    })
  })
  return dataSystem.filter(item => item.children && item.children.length > 0);
}
/**
 * 匹配指定链接内域名和域名后的字符
 * @param url
 */
export const matchUrl = (url) => {
  let pattern = "^((http://)|(https://))?([a-zA-Z0-9]([a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,6}(/)";
  let api = '';
  let path = '';
  if (url.match(pattern)) {
    api = url.match(pattern)[0];
  } else {
    api = 'null';
  }
  path = url.substr(api.length - 1, url.length - 1);
  return {
    api,
    path
  }
}

/**
 * 浮点数相加(两位)
 */
export const floatSum = (values) => {
  let sum = 0;
  for(var value in values){
    sum += Math.round(parseFloat(values[value])*100)
  }
  sum = sum/100;
  return parseFloat(sum.toFixed(2));
};

/**
 * 浮点数相加(两位)
 * 接收数组
 */
export const floatSumArray = (array) => {
  let sum = 0;
  array.forEach(item => {
    sum += Math.round(parseFloat(item)*100)
  })
  sum = sum/100;
  return parseFloat(sum.toFixed(2));
};
/**
 * 浮点数相减(两位)
 */
export const floatSub = (total,values) => {
  let sub = total*100;
  sub = sub.toFixed(2);
  for(var value in values){
    sub -= Math.round(parseFloat(values[value])*100)
  }
  sub = sub/100;
  return parseFloat(sub.toFixed(2));
};

/**
 * 两位浮点数输入格式化
 */
export function formatFloat(val) {
  val = val+""
  if(val){
    const temp = val;
    // 限制两位小数数字
    val = val.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符
    if(val){
      val = val.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的
      val = val.replace(".","$#$").replace(/\./g,"").replace("$#$",".");

      val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数

      // 10亿亿的会出现科学计数法，限制15位数字
      if(val.length > 15){
        val= val.substr(0,15)
      }

      if(val.indexOf(".")< 0){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        val= parseFloat(val);
      }else if(val.indexOf(".")> 1 && val[0] === "0"){//控制0X.XX
        val= parseFloat(val);
      }else if(val.indexOf(".") === 0 ){//控制.XX
        val= parseFloat("0"+val);
      }

    }
    return val
  }
};

// 获取当前年月日
export function getNowDate() {
  let d = new Date(),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
}
